import connector from '../utils/Connection'

export default {
    actions: {
        async register ({dispatch, commit}, registerData) {
            const result = await connector.register(registerData);
            this.state.lastResponse = result;
            return result;
        },

        async confirm({dispatch, commit}, {userPhone, code }) {
            const result = await connector.confirmRegistration(userPhone, code);
            this.state.lastResponse = result;
            this.state.userIsAdmin = false;
            if (result.error == 0) {
                this.state.userId = result.data.user_id;
                const responseUser = await connector.getUserInfo(result.data.user_id);
                if (responseUser.error == 0 && responseUser.data != null) {
                    this.state.userData = responseUser.data[0];
                    this.state.userIsAdmin = responseUser.data[0].user_role === 2;
                }
                const patientsList = await connector.getUserPatients(result.data.user_id);
                if (patientsList.error == 0) {
                    this.state.patientsList = patientsList.data;
                }
            }
            return result;
        }
    }
}